import cookieStore from './cookie';

const MOB_COOKIE_NAME = 'pb-mob-app';

// Better to use this method for detect WebView
export const isWebView = () => {
  return !!cookieStore.get(MOB_COOKIE_NAME);
};
